module.exports = __webpack_public_path__ + "img/MapThumb_Arabia.fc47052b.webp";